export function Security() {
  return (
    <section id="security" className="py-20 bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <h3 className="text-4xl font-bold mb-6">
              Your Privacy is Our <strong>Top Priority</strong>
            </h3>
            <p className="text-xl text-gray-300 mb-8 leading-relaxed">
              At <strong>TRAMETAL S.A.S</strong>, we believe that online privacy is a fundamental right. Our <strong>VPN solution</strong> is built with the most advanced security protocols to ensure your data remains completely private and protected from prying eyes.
            </p>

            <div className="space-y-6">
              <div className="flex gap-4">
                <div className="w-12 h-12 flex items-center justify-center bg-teal-600 rounded-lg flex-shrink-0">
                  <i className="ri-lock-line text-2xl"></i>
                </div>
                <div>
                  <h4 className="text-xl font-bold mb-2">
                    <a href="#security" className="hover:text-teal-400 transition-colors">
                      End-to-End Encryption
                    </a>
                  </h4>
                  <p className="text-gray-400">
                    All your internet traffic is encrypted from your device to our VPN servers, making it impossible for anyone to intercept or read your data.
                  </p>
                </div>
              </div>

              <div className="flex gap-4">
                <div className="w-12 h-12 flex items-center justify-center bg-teal-600 rounded-lg flex-shrink-0">
                  <i className="ri-shield-star-line text-2xl"></i>
                </div>
                <div>
                  <h4 className="text-xl font-bold mb-2">
                    <a href="#security" className="hover:text-teal-400 transition-colors">
                      DNS Leak Protection
                    </a>
                  </h4>
                  <p className="text-gray-400">
                    Our VPN includes built-in DNS leak protection to ensure your browsing activity never leaks outside the encrypted VPN tunnel.
                  </p>
                </div>
              </div>

              <div className="flex gap-4">
                <div className="w-12 h-12 flex items-center justify-center bg-teal-600 rounded-lg flex-shrink-0">
                  <i className="ri-refresh-line text-2xl"></i>
                </div>
                <div>
                  <h4 className="text-xl font-bold mb-2">
                    <a href="#security" className="hover:text-teal-400 transition-colors">
                      Kill Switch Technology
                    </a>
                  </h4>
                  <p className="text-gray-400">
                    If your VPN connection drops unexpectedly, our kill switch immediately blocks all internet traffic to prevent data exposure.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="relative">
            <img 
              src="https://public.readdy.ai/ai/img_res/c709a0f80e4f15201b3652d694f3a86a.jpg" 
              alt="VPN Security Protection"
              title="TRAMETAL VPN Security"
              className="w-full h-auto rounded-2xl shadow-2xl object-cover object-top"
            />
          </div>
        </div>
      </div>
    </section>
  );
}